import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ProfileService } from '../../profile/services/profile.service';
import { PermissionsService } from '../services/permissions.service';
import { PermissionsModel } from '../../shared/models/permissions.model';
import { profile } from 'console';
import { User } from '../../shared/models/user.model';

export const permissionsGuard: CanActivateFn = (route, state) => {
  const profileService = inject(ProfileService)
  const service = inject(PermissionsService)
  // console.log('Ruta Activa', state);
  const profile = profileService.profile() as User;
  if (profile?.user_type?.access) {
    return true;
  }
  const resource = profileService.extraerValor(state.url)
  // console.log('Recurso: ', resource);
  if (!resource) {
    const res = service.hasPermission(profile.role?.permissions);
    console.log('permissionsGuard: ', res);
    return res;
  }
  const res = service.hasPermission(
    profile.role?.permissions,
    resource.resource,
  );
  console.log('permissionsGuard: ', res);
  return res;
};
